export const SELECTION_HOUSE_STYLE_INSTRUCTIONS = {
  facade: {
    title: "Facade",
    description:
      "refers to the exterior design style of your home. In some cases, the same homedesign will have multiple facade choices for you to select the finished appearance of your home.",
  },
  externalColours: {
    title: "External Colour Scheme",
    description:
      "refers to the exterior design style of your home. In some cases, the same home design will have multiple facade choices for you to select the finished appearance of your home.",
  },
  internalColours: {
    title: "Internal Colour Scheme",
    description:
      "refers to the interior design style of your home. This render is indicative only and is only used to assist inchoosing an internal colour scheme",
  },
};
